import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { PartnerStockResponse, getStockForPartner } from '@apis/stock';

export const useStockDetailForPartner = (stockId: number) => {
  const queryOptions: UseQueryOptions<
    PageResponse<PartnerStockResponse>,
    Error
  > = {
    queryKey: ['stockDetailForPartner', stockId],
    queryFn: () => {
      return getStockForPartner(stockId);
    },
  };
  return useQuery(queryOptions);
};
